import PersonalityTypePage, { getStaticProps as getGeneralStaticProps } from 'ui/pages/personalityPost';
import { host } from 'utils/jsonLd/utils';
import getJsonLdWebPage from 'utils/jsonLd/webPage';
import { capitalize } from 'utils/string';

import Layout from '@/components/layouts/Layout';


export default function PersonalityType(props) {
  return <PersonalityTypePage {...props} layout={Layout}/>;
}

PersonalityType.getLayout = PersonalityTypePage.getLayout;
PersonalityType.prettyName = 'Personality Type Post';


export async function getStaticProps(...attr) {
  const res = await getGeneralStaticProps(...attr);
  const {type, title, article, } = res.props;
  const seo = article?.seo || {};
  const meta = {
    title:
      seo?.seo_title ||
      `The ${type.toUpperCase()} Personality Type: All About the ${capitalize(title)}`,
    description:
      seo?.meta_description ||
      `The ${type.toUpperCase()} personality type (also known as the "${title}") is quiet, idealistic, and creative. Learn all about INFP traits, strengths, weaknesses, and more.`,
    image: seo?.image,
  };

  const jsonLd = getJsonLdWebPage({
    name: meta.title,
    description: meta.description,
    url: `${host}/posts`,
    mainEntity:{
      "@context": "https://schema.org",
      "@type": "Article",
      "name": meta.title
    }
  });

  return {
    ...res,
    props: {
      ...res.props,
      jsonLd
    },
  };
}